module.exports = __webpack_public_path__ + "static/media/FOTO 3.7.7bfd9f52.jpg";